// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Filters
const Join = function(array: any, separator: any, prop: any) {
   if (!Array.isArray(array)) { 
      return array // if not array return original 
   }

   if (angular.isUndefined(prop)) {
      return array.join(separator)
   } else { 
      return _.map(array, (item: any) => item[prop]).join(separator)
   }
}

const SummonEscape = function(this: any, utilities: any) {
   this.utilities = utilities
   return (v: any) => {
      return this.utilities.summonEscape(v)
   }
}

const SummonTimestampToMMyyyyDate = function(this: any, $filter: any) {
   this.$filter = $filter
   return (dateText: any) => { 
      if (!dateText) { return }
  
      const timestampPattern = new RegExp(`^(0|[1-9][0-9]*)$`)
      const match = dateText.match(timestampPattern)
      if (!match || (dateText.length !== 8)) { return dateText }

      const year = dateText.substring(0,4)
      const month = dateText.substring(4,6)
      const day = dateText.substring(6,8)

      const date = new Date(year, month - 1, day)
      const angularDate = this.$filter('date')

      if (date) { 
         return angularDate(date, 'MM/yyyy')
      } else {
         return dateText
      }
   }
}


const SummonISODate = function(this: any, $filter: any) {
   this.$filter = $filter
   return (dateText: any) => {
      if (!dateText) { return }
    
      const angularDate = this.$filter('date')
    
      const date = new Date(dateText)

      if (date) { 
         return angularDate(date, 'mediumDate')
      } else {
         return dateText
      }
   }
}

const SummonISODateWithHour = function(this: any, $filter: any) {
   this.$filter = $filter
   return (dateText: any) => {
      if (!dateText) { return }
    
      const angularDate = this.$filter('date')
    
      const date = new Date(dateText)

      if (date) { 
         return angularDate(date, 'MMM dd, yyyy hh:mm a')
      } else {
         return dateText
      }
   }
}

const SummonDate = function(this: any, $filter: any) {
   this.$filter = $filter
   return (dateText: any) => {
      let day, month, year
      if (!dateText) { return }

      const angularDate = this.$filter('date')
      const datePattern = new RegExp(`\
^(\\d{2}/){0,1}\
(\\d{2}/){0,1}\
(\\d{4})$\
`)

      const match = dateText.match(datePattern)
      if (match) {
         const dateParts = match.slice(1, 4)
         if (dateParts[0]) { month = dateParts[0].replace(/\//, '') }
         if (dateParts[1]) { day = dateParts[1].replace(/\//, '') }
         year = dateParts[2]
      }

      // TODO: add support for dates w/only month and year - SUM-56319
      if (month && day && year) {
         return angularDate(new Date(year, month-1, day), 'mediumDate')
      } else {
         return dateText
      }
   }
}

const TitleCase = function(text: any) {
   if (text == null) { text = '' }
   return text.replace(/\w\S*/g, (s: any) => s.charAt(0).toUpperCase() + s.substring(1))
}

// FIXME: remove when we get nicer topic names/descriptions back from API
const TextMapping = (textMappings: any) => (text: any, group: any) => textMappings[group][text] || text

const template = function(tpl: any, substitutions: any) {
   for (var key in substitutions) {
      var value = substitutions[key]
      tpl = tpl.replace(new RegExp(`\%\{${key}\}`, "g"), value)
   }
   return tpl
}

const TRANSLATE_RX = RegExp("\%\{.*?\}")
var Translate = function(text: any, substitutions = {}) {
   let translated
   if(angular.isArray(text)) {
      for (let i = 0; i < text.length; i++) { var t = text[i]; text[i] = Translate(t, substitutions) }
      translated = text
   } else {
      // @ts-expect-error TS(2339) FIXME: Property '__translations' does not exist on type '... Remove this comment to see the full error message
      const lookup = window.__translations || {}
      try {
         translated = lookup[text] || text
      } catch (e) {
      // if all else fails
         translated = text
      }
      if (TRANSLATE_RX.test(translated)) { translated = template(translated, substitutions) }
   }
   return translated
}


//  LocaleSort filter
//
//  It is designed to compare only strings from object path attributes
//
//  @param {string[]} to be sorted by localeCompare
//  @param {string} object path to match the sort criteria
//  @param {...string} [path] other paths to match the sort criteria
//  @return {string[]} sorted Array
const LocaleSort = function(this: any, $filter: any, localizationService: any) {
   this.$filter = $filter
   const translate = this.$filter('translate')

   const locale = localizationService.getStandardLocale()

   const deepFind = function(obj: any, path: any) {
      const paths = path.split('.')
      let result = obj

      for (var p of paths) {
         if (result[p] == null) { return undefined }
         result = result[p]
      }
      return result
   }

   const sortValidator = function(a: any,b: any, paths: any){
      let stringA = ''
      let stringB = ''

      for (var path of paths) {
         stringA += translate(deepFind(a, path))
         stringB += translate(deepFind(b, path))
      }
      return stringA.localeCompare(stringB, locale)
   }

   return function(objectsArray: any, ...paths: any[]) {
      if (paths.length < 1) { throw new Error("Object paths missing") }
      // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 4.
      return objectsArray.sort((a: any, b: any) => sortValidator(a, b, paths, translate))
   }
}

const RangeFilter = function(this: any, $filter: any, i18n: any) {
   this.$filter = $filter
   this.i18n = i18n
   return (dates: any) => {
      if (!dates?.end) { return }

      let startDate = ""
      const friendlyDateMaker = this.$filter('summonTimestampToMMyyyyDate')
    
      if (dates.start) {
         startDate = friendlyDateMaker(`${dates.start}`)
      } else { 
         startDate = this.i18n.translations.COVERAGE_ZERO_START
      }

      if (dates.end === 99991231) {
         return this.i18n.translate(this.i18n.translations.COVERAGE_START_TO_PRESENT, {start: startDate })
      } else { 
         return `${startDate} - ${friendlyDateMaker(`${dates.end}`)}`
      }
   }
}

const FormatClass = (formats: any) => function(format: any, prefix = false) {
   if (format == null) { return "" }
   const normalized = format.toLowerCase().replace(/\s/g, '_')
   const fixed_format = formats[normalized] || normalized
   const pfx = prefix ? `${prefix}-` : ""
   return `format-${pfx}${fixed_format}`
}

const StartAt = (elements: any, index: any) => elements.slice(index) ?? []

const HasDetailPage = function(this: any, docService: any) {
   this.docService = docService
   return (doc: any) => {
      if (!doc) { return }
      return this.docService.displayDetailPage(doc) || this.docService.displayAIPage(doc)
   }
}

const IsArray = (ref: any) => angular.isArray(ref)

const HasValue = (ref: any) => ref && (ref.length > 0)

const FormatNumber = ($window: any) => function(val: any, notation: any) {
   if (notation == null) { notation = {style: 'decimal'} }
   return new Intl.NumberFormat($window.__summonLocale, notation).format(val)
}

//TODO this does not work correctly for some reason... it sometimes shows one or two highlighted chars but then not anymore
const Highlight = ($sce: any) => function(text: any, phrase: any) { 
   if (phrase) {
      text = text.replace(new RegExp('('+phrase+')', 'gi'), '<span class="highlighted">$1</span>')
   }
   return $sce.trustAsHtml(text)
}

angular.module('summonApp.filters')
// filters
   .filter('summonEscape', ['utilitiesService', SummonEscape])
   .filter('titleCase', () => TitleCase)
   .filter('formatClass', ['$formats', FormatClass])
   .filter('translate', () => Translate)
   .filter('localeSort', ['$filter', 'localizationService', LocaleSort])
   .filter('join', () => Join)
   .filter('startAt', () => StartAt)
   .filter('summonISODate', ['$filter', SummonISODate])
   .filter('summonISODateWithHour', ['$filter', SummonISODateWithHour])
   .filter('summonDate', ['$filter', SummonDate])
   .filter('summonTimestampToMMyyyyDate', ['$filter', SummonTimestampToMMyyyyDate])
   .filter('range', ['$filter', 'translationService', RangeFilter])
   .filter('hasDetailPage', ['documentService', HasDetailPage])
   .filter('isArray', () => IsArray)
   .filter('hasValue', () => HasValue)
   .filter('formatNumber', ['$window', FormatNumber])
// fixes
   .filter('textMapping', ['$filterTextMappings', TextMapping])
   .filter('highlight', ['$sce', Highlight])
